import network from './network.service';


// Interfaces
export interface ResolveResponse {
  orderRefId: string,
  status: string | number,
  errorMessage: string | null,
  qrCode: string | null,
}

export interface BeginResponse {
  orderRefId: string,
  autoStartToken: string | null,
}


// Calls
// TODO:https://gitlab.group.team.blue/odin/software/php/cart/-/blob/master/storage/api-docs/openapi.json?ref_type=heads
export const beginBankIdSession = async (
  onDeviceAppAuth: boolean,
): Promise<BeginResponse> => {
  const response = await network.post<BeginResponse>('/bankid/begin-bankid-session', {onDeviceAppAuth});

  return response.data;
};

export const resolveBankIdSession = async (
  orderRefId: string
): Promise<ResolveResponse> => {
  const response = await network.post<ResolveResponse>('/bankid/resolve-bankid-session', {orderRefId});

  return response.data;
};

export const invalidateBankId = async (): Promise<void> => {
  await network.post('/users/creditsafe-invalidate');
};
